/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import gitignoreImg from 'assets/images/gitignore.png'

export const _7 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>7 - Файл .gitignore</h2>
    <p className={styles.description}>
      Если создать файл .gitignore в своем репозитории, Git использует его, чтобы определить, какие файлы и каталоги
      (или целые шаблоны) игнорировать, прежде чем совершать коммит. Обычно он используется, чтобы избежать передачи
      временных файлов из вашего рабочего каталога, которые не являются полезными для других соавторов, таких как
      продукты компиляции, файлы настроек проекта, созданные средой разработки и т.д.
    </p>
    <p className={styles.notificationWarn}>
      <code className={styles.code}>.gitignore</code>
      это не расширение файла, а его имя. В проводнике windows создать такой файл не получится, возьмите
      <code className={styles.code}>.gitignore</code> с вебинара или создайте его при инициализации вашего репозитория
      для домашних работ.
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>7.1 - Правила синтаксиса в .gitignore</h3>
      <ul className={styles.list}>
        <li className={styles.list__item}>Одна строчка - одно правило</li>
        <li className={styles.list__item}>Пустые строки игнорируются</li>
        <li className={styles.list__item}>Комментарии доступны через решётку(#) в начале строки</li>
        <li className={styles.list__item}>
          Символ "/" в начале строки указывает, что правило применяется только к файлам и папкам, которые располагаются
          в той же папке, что и сам файл .gitignore
        </li>
        <li className={styles.list__item}>
          Можно использовать спецсимволы: звёздочка(*) заменяет любое количество символов(ноль или больше), вопрос(?)
          заменяет от нуля до одного символа. Спецсимволы можно размещать в любом месте правила
        </li>
        <li className={styles.list__item}>
          Две звёздочки(**) используются для указания любого количества поддиректорий, подробнее смотри ниже в примерах
        </li>
        <li className={styles.list__item}>
          Восклицательный знак(!) в начале строки означает инвертирование правила, необходим для указания исключений из
          правил игнорирования
        </li>
        <li className={styles.list__item}>
          Символ "\" используется для экранирования спецсимволов, например, чтобы игнорировать файл с именем
          "!readme!.txt", нужно написать такое правило: "\!readme!.txt"
        </li>
        <li className={styles.list__item}>
          Для игнорирования всей директории, правило должно оканчиваться на слэш(/), в противном случае правило
          считается именем файла
        </li>
      </ul>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>7.2 - Пример записи файла .gitignore</h3>
      <img className={styles.img} src={gitignoreImg} alt="gitignore" />
    </section>
  </section>
))
